import { Loader2 } from 'lucide-react'
import { cn } from '../lib/utils'

interface Props {
  /** 화면 전체를 덮을지 여부. false 면 흐름 안에 인라인으로 표시 */
  full?: boolean
  label?: string
}

export function LoadingState({ full = false, label = '불러오는 중…' }: Props) {
  return (
    <div className={cn('flex items-center justify-center', full ? 'min-h-dvh' : 'py-10')}>
      <div className="flex flex-col items-center gap-3">
        <Loader2 className="size-7 animate-spin text-primary" />
        <span className="text-sm text-slate-500">{label}</span>
      </div>
    </div>
  )
}
